// extracted by mini-css-extract-plugin
export default {"progress-bg":"Mint-Progress_progress-bg__mb9Ie","progress":"Mint-Progress_progress__Q3r2j"};